module.exports = __webpack_public_path__ + "img/4.5129478e.jpg";